import { Stack, Typography } from '@mui/material';

import { AISuggestionReviewCellDisplayItemProps } from '@/modules/aiSuggestionReviewCard/components/AISuggestionReviewCell';
import { SuggestionNotesHelp } from '@/modules/aiSuggestions/components/SuggestionNotesHelp';

export interface AISuggestionReviewLeadingCellProps {
  values: AISuggestionReviewCellDisplayItemProps[];
  /**
   * Optional secondary line rendered below the title.
   */
  subtitle?: string;
}

/**
 * The first cell of an AI suggestion row. Renders the suggestion's title in
 * `title-xs` (bold navy) with an optional subtitle below in `text-secondary`.
 * Trailing columns use `AISuggestionReviewCell`. The leading cell never
 * carries a warning state — that lives on the trailing detail cells.
 */
export function AISuggestionReviewLeadingCell({
  values,
  subtitle,
}: AISuggestionReviewLeadingCellProps) {
  return (
    <Stack direction="column" gap={0.25} justifyContent="center" height="100%">
      <Stack direction="row" flexWrap="wrap" gap={0.5}>
        {values.map((value, index) => (
          <Stack
            // Index-keyed: displayText is not unique across values, and
            // duplicate keys corrupt reconciliation when values transition.
            key={index}
            direction="row"
            alignItems="center"
            gap={0.25}
          >
            <Typography
              variant="title-xs"
              data-testid="ai-suggestion-leading-cell-normal"
            >
              {value.displayText}
              {index === values.length - 1 ? '' : ','}
            </Typography>
            <SuggestionNotesHelp notes={value.notes} />
          </Stack>
        ))}
      </Stack>
      {subtitle && <Typography variant="body-xs">{subtitle}</Typography>}
    </Stack>
  );
}
